module.exports = __webpack_public_path__ + "static/media/Wolf_meat.975ec370.png";